import { Modal, Form, Button, Col, Row, Spin, Progress } from "antd"
import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setViewFileModalVisible } from "../redux/action/Components"
import { HiDownload } from 'react-icons/hi'
import { FaHandPointLeft, FaHandPointRight } from 'react-icons/fa'
import { Document, Page, pdfjs } from 'react-pdf'
import { BrowserView, MobileView } from 'react-device-detect';
import ImageLoad from "./ImageLoad"
import { toFileUrl, FILE_OFFNET_HINT } from "../helper/blobFileUrl"

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.js`;

// pdf.js 需要 CMap 才能顯示「未內嵌 CJK 字型」的文字(例如 SAP/ERP 產出的採購單:MSung-Light、STSong-Light 等),
// 否則只會畫出線條與圖片、文字整頁空白。standard_fonts 則供未內嵌的標準 14 字型(Helvetica 等)使用。
// 檔案放在 public/pdfjs/(取自 pdfjs-dist 2.16.105,需與 react-pdf 內含版本一致),由站台自己提供,
// 不依賴外部 CDN(公司網路可能擋外部網域)。物件宣告在元件外以免每次 render 重新載入文件。
// 注意:pdf.js 是在 worker 內抓 CMap,而 worker 來自 cdnjs(跨網域),所以這裡必須是「絕對網址」,
// 寫成 /pdfjs/cmaps/ 相對路徑會在 worker 內 "Failed to parse URL",文字一樣空白。
const PDF_ASSET_BASE = `${window.location.origin}${process.env.PUBLIC_URL || ""}/pdfjs`;
const PDF_OPTIONS = {
  cMapUrl: `${PDF_ASSET_BASE}/cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: `${PDF_ASSET_BASE}/standard_fonts/`,
};

export default function ViewFileModal(props){

  const [ curFilePage, setCurFilePage ] = useState(0)
  const viewFileModalVisible = useSelector(state => state.Modal.viewFileModalVisible)
  const viewFileData = useSelector(state => state.Stamp.viewFileData)
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [isPDFLoaded, setIsPDFLoaded] = useState(false)
  const [percent, setPercent] = useState(0)
  const [loadError, setLoadError] = useState(false)
//  useEffect(()=>{
//   console.log(viewFileData)
//     viewFileData.map((image, index)=>{
//       if(image.type !== 'application/pdf'){
//         const imageElement = new Image();
//         imageElement.src = image;
//         console.log(imageElement)
//       }
//     })
//   },[viewFileData])
  const viewPDF = () =>{
    function onDocumentLoadSuccess({ numPages }) {
      setNumPages(numPages);
    }

    return (
      <div>
        <div style={{minHeight:'30vh'}}>
          <Document 
            style={{width:'100%'}}
            loading='載入中...'
            className={'PDFViewer'}
            file={toFileUrl(viewFileData[curFilePage].url)} 
            options={PDF_OPTIONS}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadProgress={({ loaded, total }) => { 
              setIsPDFLoaded(false)
              setPercent(parseInt(loaded*100/total))
              if(loaded === total){
                setIsPDFLoaded(true)
                setPercent(0)
              }
            }}
            onLoadError={() => { setLoadError(true); setIsPDFLoaded(true); setPercent(0); }}
            error={<div style={{ color: "#d46b08", padding: "20px", textAlign: "center" }}>{FILE_OFFNET_HINT}</div>}
          >
            <Page 
              loading='載入中...'
              pageNumber={pageNumber} 
            />
          </Document>
        </div>

        {
          isPDFLoaded ?
          <>
            <Row style={{ paddingTop: '10px' }} justify="space-between" gutter={16}>
              <Col>
                <Button type='primary' disabled={pageNumber <= 1} onClick={() => setPageNumber(pageNumber - 1)} style={{ width: '100%' }} icon={<FaHandPointLeft/>}> 上一頁 </Button>
              </Col>
              <Col>
                <Button type='primary' disabled={pageNumber === numPages} onClick={() => setPageNumber(pageNumber + 1)} style={{ width: '100%' }} icon={<FaHandPointRight/>}> 下一頁 </Button>
              </Col>
            </Row>
            <p className="pageInfo">
              第 {pageNumber} 頁，共 {numPages} 頁
            </p> 
          </>:null
        }
      </div>
    );
  }
  const fileShow = ()=>{
    return viewFileData.map((data, index)=>{
      if(data.type === 'application/pdf'){
        return <Spin style={index === curFilePage ?{position: 'fixed', top: '25%'}: {display:'none'}} tip={<Progress style={{width:'50vw'}} percent={percent}/>} spinning={!isPDFLoaded && !loadError}><div style={index === curFilePage ?{}: {display:'none'}}>{viewPDF()}</div></Spin>
      }else{
        // return <embed style={index === curFilePage ?{maxHeight: '60vh', maxWidth: '100%', minHeight:'30vh'}: {display:'none'}} src={data.url} type={data.type}/>
        // return <>{!isImgLoaded&&<>123</>}<img onLoad={() => setIsImgLoaded(true)} style={index === curFilePage ?{maxHeight: '60vh', maxWidth: '100%', minHeight:'30vh'}: {display:'none'}} src={data.url}/></>
        return <ImageLoad show={index === curFilePage} url={toFileUrl(data.url)}/>
      }
    })
  }

  return(
    <>
      <BrowserView>
        <Modal
          title='查看檔案'
          visible={viewFileModalVisible}
          onCancel={() => { dispatch(setViewFileModalVisible(false)); setPageNumber(1); setCurFilePage(0); setLoadError(false);}}
          width={'60%'}
          footer={null}
          maskClosable={false}
        >
          <Form
            form={form}
          >
            <Row justify='end' style={{ width: '100%' }}>
              {
                viewFileData.length !== 0 ?
                  <Col xs={12} sm={8} lg={4} span={6}>
                    <Button style={{ width: '100%', height: 'auto' }} type="primary" icon={<HiDownload />} disabled={loadError} href={loadError ? undefined : toFileUrl(viewFileData[curFilePage].url)} > 下載檔案 </Button>
                  </Col>
                : null
              }
            </Row>
            <Col style={{ display: 'flex', justifyContent: 'center', paddingTop: '30px' }} span={24}>
            { 
              // viewFileData.length !== 0  ? 
              // viewFileData[curFilePage].type === 'application/pdf' ?
              //   viewPDF()
              // : 
              // <embed style={{ maxHeight: '60vh', maxWidth: '100%' }} src={viewFileData[curFilePage].url} type={viewFileData[curFilePage].type}/> : 
              // null 
              fileShow()
            }
            </Col>
            <Row style={{ paddingTop: '30px'}} justify='space-between'>
              <Button type='primary' disabled={curFilePage === 0} onClick={() =>{ setCurFilePage(curFilePage - 1); setPageNumber(1); setIsPDFLoaded(false); setLoadError(false)}}> 上一個檔案 </Button>
              <Button type='primary' disabled={viewFileData.length -1 === curFilePage} onClick={() =>{ setCurFilePage(curFilePage + 1); setPageNumber(1); setIsPDFLoaded(false); setLoadError(false)}}> 下一個檔案 </Button>
            </Row>
          </Form>
        </Modal>
      </BrowserView>
      <MobileView>
        <Modal
          title='查看檔案'
          visible={viewFileModalVisible}
          onCancel={() => { dispatch(setViewFileModalVisible(false)); setPageNumber(1); setCurFilePage(0); setLoadError(false);}}
          width={'80%'}
          footer={null}
          style={{ height: '80vh' }}
        >
          <Form
            form={form}
          >
            <Row justify='end' style={{ width: '100%' }}>
              {
                viewFileData.length !== 0 ?
                  <Col span={12}>
                    <Button style={{ width: '100%', height: 'auto' }} type="primary" icon={<HiDownload />} disabled={loadError} href={loadError ? undefined : toFileUrl(viewFileData[curFilePage].url)} > 下載檔案 </Button>
                  </Col>
                : null
              }
            </Row>
            <Col style={{ display: 'flex', justifyContent: 'center', paddingTop: '30px' }} span={24}>
            { 
              // viewFileData.length !== 0  ? 
              //   viewFileData[curFilePage].type === 'application/pdf' ?
              //     viewPDF()
              // : 
              // <embed style={{ maxHeight: '60vh', maxWidth: '100%' }} src={viewFileData[curFilePage].url} type={viewFileData[curFilePage].type}/> : 
              // null 
              fileShow()
            }
            </Col>
            <Row style={{ paddingTop: '30px'}} justify='space-between'>
              <Col span={8}>
                <Button type='primary' style={{ width: '100%' }} disabled={curFilePage === 0} onClick={() =>{ setCurFilePage(curFilePage - 1); setPageNumber(1); setIsPDFLoaded(false); setLoadError(false)}}> 上一個檔案 </Button>
              </Col>
              <Col span={8}>
                <Button type='primary' style={{ width: '100%' }} disabled={viewFileData.length -1 === curFilePage} onClick={() =>{ setCurFilePage(curFilePage + 1); setPageNumber(1); setIsPDFLoaded(false); setLoadError(false)}}> 下一個檔案 </Button>
              </Col>
            </Row>
          </Form>
        </Modal>
      </MobileView>
    </>
  )
}